import {
	PendaftaranPasienListPage,
	PendaftaranPasienAddPage,
	PendaftaranPasienDetailPage,
	PendaftaranPasienEditPage,
	PendaftaranPasienFileAddPage,
} from "pages/AdminAdmission/PendaftaranPasien";
import {AppointmentListPage, AppointmentAddPage, AppointmentDetailPage} from "pages/AdminAdmission/Appointment";
import {CheckInPatientsDetailPage, CheckInPatientsListPage} from "pages/AdminAdmission/CheckInPatients";
import {KasirAddPage, KasirDetailPage, KasirListPage} from "pages/AdminAdmission/Kasir";
import {ReviewAddPage, ReviewDetailPage, ReviewEditPage, ReviewListPage} from "pages/AdminAdmission/Review";
import {UserAttendanceMePage} from "pages/Attendance/UserAttendanceMe";

export const adminAdmissionRoutes = [
	{
		name: "admin-admission-master-pasien",
		path: "/pendaftaran-pasien",
		exact: true,
		isPrivate: true,
		component: PendaftaranPasienListPage,
	},
	{
		name: "admin-admission-tambah-pasien",
		path: "/pendaftaran-pasien/tambah",
		exact: true,
		isPrivate: true,
		component: PendaftaranPasienAddPage,
	},
	{
		name: "admin-admission-detail-pasien",
		path: "/pendaftaran-pasien/show/:id",
		exact: true,
		isPrivate: true,
		component: PendaftaranPasienDetailPage,
	},
	{
		name: "admin-admission-edit-pasien",
		path: "/pendaftaran-pasien/edit/:id",
		exact: true,
		isPrivate: true,
		component: PendaftaranPasienEditPage,
	},
	{
		name: "admin-laboratoriun-master-file-lab-add",
		path: "/file-labs/tambah/:idPatient",
		exact: true,
		isPrivate: true,
		component: PendaftaranPasienFileAddPage,
	},
	{
		name: "admin-admission-appointment-list",
		path: "/admission/appointment/list",
		exact: true,
		isPrivate: true,
		component: AppointmentListPage,
	},
	{
		name: "admin-admission-appointment-add",
		path: "/admission/appointment/add",
		exact: true,
		isPrivate: true,
		component: AppointmentAddPage,
	},
	{
		name: "admin-admission-appointment-edit",
		path: "/admission/appointment/edit/:id",
		exact: true,
		isPrivate: true,
		component: AppointmentAddPage,
	},
	{
		name: "admin-admission-appointment-detail",
		path: "/admission/appointment/detail/:id",
		exact: true,
		isPrivate: true,
		component: AppointmentDetailPage,
	},
	{
		name: "admin-admission-checkin-patients",
		path: "/admission/checkin-patients/list",
		exact: true,
		isPrivate: true,
		component: CheckInPatientsListPage,
	},
	{
		name: "admin-admission-checkin-patients-detail",
		path: "/admission/checkin-patients/detail/:id",
		exact: true,
		isPrivate: true,
		component: CheckInPatientsDetailPage,
	},
	{
		name: "admin-admission-kasir-list",
		path: "/admission/kasir/list",
		exact: true,
		isPrivate: true,
		component: KasirListPage,
	},
	{
		name: "admin-admission-kasir-detail",
		path: "/admission/kasir/detail/:id",
		exact: true,
		isPrivate: true,
		component: KasirDetailPage,
	},
	{
		name: "admin-admission-kasir-edit",
		path: "/admission/kasir/edit/:id",
		exact: true,
		isPrivate: true,
		component: KasirAddPage,
	},
	{
		name: "admin-admission-kasir-add",
		path: "/admission/kasir/add",
		exact: true,
		isPrivate: true,
		component: KasirAddPage,
	},
	{
		name: "admission-review-list",
		path: "/admission/review/list",
		exact: true,
		isPrivate: true,
		component: ReviewListPage,
	},
	{
		name: "admission-review-create",
		path: "/admission/review/create",
		exact: true,
		isPrivate: true,
		component: ReviewAddPage,
	},
	{
		name: "admission-review-edit",
		path: "/admission/review/edit/:id",
		exact: true,
		isPrivate: true,
		component: ReviewEditPage,
	},
	{
		name: "admission-review-detail",
		path: "/admission/review/show/:id",
		exact: true,
		isPrivate: true,
		component: ReviewDetailPage,
	},
	{
		name: "absensi-staff",
		path: "/absensi-staff",
		exact: true,
		isPrivate: true,
		component: UserAttendanceMePage,
	},
];
